<!--
 * @Date: 2020-07-20 18:12:30
 * @LastEditTime: 2021-02-08 09:49:05
 * @Description: app管理
--> 

<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 返回 -->
      <el-tab-pane name="five">
        <span slot="label">
          <i class="el-icon-back" style="font-size: 20px"></i>
        </span>
      </el-tab-pane>
      
      <!-- 设备留存 -->
      <el-tab-pane name="first" v-if="isShow === 1">
        <span slot="label" style="font-size: 16px">新 增</span>
        <add-component></add-component>
      </el-tab-pane>
      <el-tab-pane name="second" v-if="isShow === 1">
        <span slot="label" style="font-size: 16px">日 活</span>
        <day-live></day-live>
      </el-tab-pane>
      <el-tab-pane name="third" v-if="isShow === 1">
        <span slot="label" style="font-size: 16px">留 存</span>
        <retained></retained>
      </el-tab-pane>

      <!-- 收入数据 -->
      <el-tab-pane name="first" v-if="isShow === 2">
        <span slot="label" style="font-size: 16px">明细汇总</span>
        <income-all></income-all>
      </el-tab-pane>
      <el-tab-pane name="second" v-if="isShow === 2">
        <span slot="label" style="font-size: 16px">明细</span>
        <income></income>
      </el-tab-pane>

      <!-- 事件留存 -->
      <el-tab-pane name="first" v-if="isShow === 3">
        <span slot="label" style="font-size: 16px">事件留存</span>
        <event></event>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import addComponent from "../TotalReport";
import dayLive from "../TotalReport3";
import retained from "../TotalReport2";
import income from "../Income";
import incomeAll from "../IncomeAll";
import event from "../TotalEvent"

export default {
  components: {
    addComponent,
    dayLive,
    retained,
    income,
    incomeAll,
    event
  },

  computed: {
    isShow() {
      // type 1:设备留存 2:收入数据 3:事件留存
      return +this.$route.query.type
    },
  },

  data() {
    return {
      activeName: "first",
    };
  },

  created() {
    console.log(window.location.search);
  },
  
  mounted() {
    console.log(this.$route.query.type);
  },

  methods: {
    handleClick(tab) {
      if (+tab.index === 0) {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.container {
  margin: 20px;
}

.top-bar {
  display: flex;
  position: relative;
  // height: 40px;
  .tb-item {
  }
}
// .top-bar:after {
//   content: "";
//   background: #e4e7ed;
//   width: 100%;
//   height: 2px;
//   display: block;
//   position: absolute;
//   left: 0;
//   bottom: 0;
// }
.el-tabs {
  width: 100%;
}
.el-tabs__item {
  font-size: 16px;
}
</style>